import { ClientPropertyVehicleTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { CarFormInput } from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";

export const CAR_FORM_DEFAULT_VALUES: CarFormInput = {
	carBrand: "",
	carModel: "",
	propertyType: ClientPropertyVehicleTypeEnum.CarUpTo3_5t,
	carFuel: null,
	carLicensePlate: "",
	carVin: "",
	value: null,
	carPurchaseDate: null,
	carRegistration: null,
	carManufactureMonthYear: null,
	carPower: null,
	carVolume: null,
	description: "",
	forInvestments: false,
};
